export enum ServerEventType {
  ThreadCreated = 'ThreadCreated',
  ThreadUpdated = 'ThreadUpdated',
  ThreadDeleted = 'ThreadDeleted',
  CommentCreated = 'CommentCreated',
  CommentUpdated = 'CommentUpdated',
  CommentDeleted = 'CommentDeleted',
}
